import React from "react";
import PropTypes from "prop-types";
import ListboxSelect from "./listbox-select";
import NumericInput from "./numeric-input";
var defaultOptions = [{
  label: "Days",
  value: "days"
}, {
  label: "Weeks",
  value: "weeks"
}, {
  label: "Months",
  value: "months"
}, {
  label: "Years",
  value: "years"
}];

var RollingDateInput = function RollingDateInput(_ref) {
  var onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      options = _ref.options,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var unitOptions = options || defaultOptions;
  var tempCount = value.split("-")[0] || null;
  var tempUnit = value.split("-")[1] || null;

  var handleChange = function handleChange(count, unit) {
    onChange("".concat(count, "-").concat(unit));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "et--rolling-date"
  }, /*#__PURE__*/React.createElement(NumericInput, {
    "aria-label": "Time count",
    className: "et--rolling-date-number",
    value: tempCount || "",
    onChange: function onChange(count) {
      return handleChange(count, tempUnit);
    },
    disabled: disabled,
    allowZero: false
  }), /*#__PURE__*/React.createElement(ListboxSelect, {
    label: "Time units",
    placeholder: "Select...",
    className: "et--rolling-date-unit",
    onChange: function onChange(unit) {
      return handleChange(tempCount, unit.value);
    },
    value: unitOptions.find(function (option) {
      return option.value === tempUnit;
    }),
    options: unitOptions,
    disabled: disabled
  }));
};

RollingDateInput.propTypes = {
  /**
   * onChange callback function
   */
  onChange: PropTypes.func.isRequired,

  /**
   * Value should be a string in the format [count]-[unit] (e.g. 2-months) where
   * the unit is one of the options in the options array and the count is a number
   */
  value: PropTypes.string,

  /**
   * Options for the units. If none are provided, it will default to Days, Weeks, Months, and Years
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),

  /**
   * Should disable both NumericInput and unit dropdown
   */
  disabled: PropTypes.bool
};
export default RollingDateInput;